module.exports = __webpack_public_path__ + "img/exclamation.8d80f8dd.png";